import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: {},
  club_list: {},
  total_list: 0,
  isUploading: false,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {}
};

// getters
const getters = {
  getClubList: (state) => () => {
    return state.club_list;
  },
  getList: (state, getters, rootState) => type => {
    var aClubs = [];
    for (var i in state.list) {
      if (state.list[i].visible) aClubs.push(state.list[i]);
    }

    return aClubs;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aClubs = [];
    for (var i in state.list) {
      aClubs.push(state.list[i]);
    }
    return aClubs;
  },

  get_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") {
      var club = { ...state.list[id] };
      for (var k in club) {
        if (club[k] == "true") club[k] = true;
        else if (club[k] == "false") club[k] = false;
        else if (parseInt(club[k]) == club[k]) club[k] = parseInt(club[k]);
      }

      return club;
    }
    return false;
  }
};

// actions
const actions = {
  fetchByEventList({ commit }, event_id) {
    const path = `club/event/${event_id}/list`;
    return api.get(path).then((response) => {
      if (response.status) {
        const clubs = response.data;
        commit("setClubList", clubs);
      }
    });
  },
  loadList({ commit, state }, params) {
    var path =
      "club" +
      (typeof params !== "undefined" && typeof params.event !== "undefined"
        ? "/event/" + params.event
        : "");
    var page_options =
      params && params.page_options ? params.page_options : state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    if (typeof params.event == "undefined") {
      delete oParams.gestor_id;
    }

    return api.post(path, oParams).then(function(response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "club/" + params.id;
    if (typeof params.event !== "undefined" && params.event !== null)
      path += "/event/" + params.event;

    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addClub", data);
      }
    });
  },

  uploadFiles(context, data) {
    return new Promise((resolve, reject) => {
      var files = data.files;
      var club = data.club;

      if (files.length == 0) {
        resolve(club);
      } else {
        var file = files.pop();
        var uploaderFile = new Uploader();
        uploaderFile.upload(
          file.file,
          {},
          function(data) {
            club[file.param] = data.Location;
            context
              .dispatch("uploadFiles", { files: files, club: club })
              .then(resolve);
          },
          function(e) {
            context
              .dispatch("uploadFiles", { files: files, club: club })
              .then(resolve);
          }
        );
      }
    });
  },

  upload(context, data) {
    var club = { ...data.data };
    club.event = data.event ? data.event.id : null;
    delete club.shield_preview;

    var params = data.params;
    var filesUpload = [];
    for (var k in params) {
      var param = params[k];
      if (
        param.type == "image" &&
        typeof club[param.param] !== "string" &&
        typeof club[param.param] !== "undefined" &&
        club[param.param] != null
      ) {
        filesUpload.push({ param: param.param, file: club[param.param] });
      }
    }
    context.commit("isUploading", true);
    return context
      .dispatch("uploadFiles", { files: filesUpload, club: club })
      .then(function(club2) {
        if (!context.getters.isUploading) {
          var path =
            typeof club2.id !== "undefined"
              ? "club/" + club2.id + "/update"
              : "club/add";
          return api.post(path, club2).then(function(response) {
            if (response.status) {
              var data = response.data;
              data.visible = true;

              context.commit("addClub", data);
              return data.id;
            }
          });
        }
      });
  },

  remove(context, id) {
    return api.post("club/" + id + "/remove", {}).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("removeClub", id);
      }
    });
  },

  addRelClubEvent(context, params) {
    return api
      .post(
        "club/" + params.club_id + "/event/" + params.event_id + "/addrel",
        { user_id: params.user_id }
      )
      .then(function(response) {
        if (response.status) {
          return true;
        } else {
          throw response.error.message;
        }
      });
  },

  createUserZE(context, params) {
    return api
      .post(
        "club/" + params.club_id + "/event/" + params.event + "/addGestor",
        {}
      )
      .then(function(response) {
        if (response.status) {
          return true;
        } else {
          throw response.error.message;
        }
      });
  },

  changeUser(context, params) {
    return api
      .post("club/" + params.id + "/changeGestor", {
        gestor_id: params.gestor_id,
        event_id: params.event_id
      })
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          data.visible = true;

          context.commit("addClub", data);
          return context.commit(
            "applyFilters",
            context.rootGetters["navigation/getCurrentFilters"]
          );
        } else {
          throw response.error.message;
        }
      });
  },

  resendAccesTeamZone(context, params) {
    return api
      .post(
        "club/" +
          params.club_id +
          "/event/" +
          params.event +
          "/send/mailteamzone",
        {}
      )
      .then(function(response) {
        if (response.status) {
          return true;
        } else {
          throw response.error.message;
        }
      });
  },

  changeStatus(context, params) {
    return api
      .post(
        "club/" + params.id + "/event/" + params.event_id + "/update/status",
        { status: params.status }
      )
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          data.list_visible = true;

          context.commit("addClub", data);
        }
      });
  }
};

// mutations
const mutations = {
  setClubList(state, clubs) {
    state.club_list = clubs;
  },

  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addClub(state, club) {
    var list = { ...state.list };
    list[club.id] = club;

    state.list = list;
  },
  removeClub(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // console.log( "--- CLUBS APPLY FILTERS ---", filters )
    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log( " ---- ITEM " + item.name + " --- " );
    //     var bFound = true;
    //     for (var k in filters) {
    //       // console.log( "--- KEY: " + k + " ---" )
    //       if (filters[k] != -1) {
    //         var item_value =
    //           item[k] != null && typeof item[k] == "object"
    //             ? item[k].id
    //             : item[k];
    //         if (
    //           item.hasOwnProperty(k) &&
    //           filters[k] == null &&
    //           item_value == null
    //         ) {
    //         } else {
    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

    //           if (filters[k] != null && typeof filters[k] === "boolean")
    //             filters[k] = filters[k] ? 1 : 0;
    //           else if (filters[k] != null && typeof filters[k] === "string")
    //             filters[k] = filters[k].trim();

    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           var regexp = new RegExp(filters[k], "gi");

    //           if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] == "object" &&
    //             filters[k] != item_value
    //           ) {
    //             bFound = false;
    //           } else if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] !== "object" &&
    //             !item_value.match(regexp)
    //           ) {
    //             bFound = false;
    //           }
    //         }
    //       }
    //     }

    //     list[i].visible = bFound;
    //   }
    // }

    // state.list = list;
  },

  isUploading(state, value) {
    state.isUploading = false;
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
